import constate from "constate";
import { useCallback, useMemo, useState } from "react";

// Page-load-scoped storage. Persists across route navigation, but resets on provider unmount (page reload, login).
function useWorkplaceSuggestionClose() {
  const [isClosedThisPageLoad, setIsClosedThisPageLoad] = useState(false);

  const markClosed = useCallback(() => {
    setIsClosedThisPageLoad(true);
  }, []);

  return useMemo(() => ({ isClosedThisPageLoad, markClosed }), [isClosedThisPageLoad, markClosed]);
}

export const [WorkplaceSuggestionCloseProvider, useWorkplaceSuggestionCloseState] = constate(
  useWorkplaceSuggestionClose
);
